import { FC } from 'react';
import Postcode from 'react-daum-postcode';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';


interface IProps {
  postcodeVisible: boolean;
  setPostcodeVisible: (visible: boolean) => void;
  onCompletePostcode: (data: any) => void;
};

const SearchPostcodeModal: FC<IProps> = ({
  postcodeVisible, setPostcodeVisible, onCompletePostcode
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      title={t('student.student.button11')}
      visible={postcodeVisible}
      onCancel={() => setPostcodeVisible(false)}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic gray'
            onClick={() => setPostcodeVisible(false)}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      <Postcode
        onComplete={onCompletePostcode}
        autoClose={false}
      />
    </Modal>
  );
}

export default SearchPostcodeModal;
